import React from "react";

const VersionFooter = () => {
    return (
        <div
            style={{
                position: "fixed",
                bottom: 0,
                left: "50%",
                transform: "translate(-50%, 0)",
                fontSize: 12,
                textAlign: "center",
                color: "#000",
                padding: "10px 0",
            }}
        ></div>
    );
};

export default VersionFooter;
